import { Box, Chip, CssBaseline, Paper, Stack, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { arSA } from "@mui/material/locale";
import { arSD } from "@mui/x-data-grid/locales";
import RTLDataGrid from "components/styled-component/RTLDataGrid";

// Format number with commas for Arabic
const formatNumber = (num) => {
  return new Intl.NumberFormat("ar-EG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

const AccountDataGrid = ({ title, accounts, total, icon, color }) => {
  // Define columns for DataGrid
  const columns = [
    {
      field: "code",
      headerName: "رمز الحساب",
      flex: 1,
      renderCell: (params) => <Chip label={params.value} size="small" variant="outlined" color="primary" sx={{p:1}} />,
    },
    {
      field: "name",
      headerName: "اسم الحساب",
      flex: 1,
    },
    {
      field: "opening_balance",
      headerName: "رصيد افتتاحي",
      flex: 1,

      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "debit_total",
      headerName: "مدين",
      flex: 1,

      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "credit_total",
      headerName: "دائن",
      flex: 1,

      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "balance",
      headerName: "الرصيد",
      flex: 1,
      valueFormatter: (value) => formatNumber(value),
      cellClassName: "font-bold",
    },
  ];

  // Map accounts to rows
  const rows = accounts.map((account) => ({
    id: account.id,
    code: account.code,
    name: account?.name,
    opening_balance: account?.details?.opening_balance,
    debit_total: account?.details?.debit_total,
    credit_total: account?.details?.credit_total,
    balance: account?.balance,
  }));

  return (
    <>
      <Box
        sx={{
          p: 2,
          background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)`,
          color: "white",
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          {icon}
          <Typography variant="h6" fontWeight="bold">
            {title}
          </Typography>
        </Stack>
      </Box>
      {/* <Box sx={{ width: "100%", direction: "rtl" }}> */}
      {/* <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          localeText={arSD.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: GridToolbar,
            footer: () => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 2,
                  backgroundColor: `${color}15`,
                  color: color,
                  fontWeight: 700,
                  fontSize: "1.1rem",
                }}
              >
                <Typography>الإجمالي</Typography>
                <Typography>{formatNumber(total)}</Typography>
              </Box>
            ),
          }}
          sx={{
            "& .MuiDataGrid-root": {
              direction: "rtl",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            },
            "& .font-bold": {
              fontWeight: 600,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f5f5f5",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        /> */}
      <CssBaseline />
      
        <RTLDataGrid
          rows={rows}
          columns={columns}
          isActions={false}
          getRowId={(row) => row.id}
          paginationMode="server"
          /* rowCount={data?.pagination?.total || 0} */
          pageSizeOptions={[10, 20, 50]}
          /* paginationModel={{ page: page - 1, pageSize }}
                      onPaginationModelChange={(model) => {
                        handlePageChange(model.page);
                        handlePageSizeChange(model.pageSize);
                      }} */
          localeText={arSD.components.MuiDataGrid.defaultProps.localeText}
          disableRowSelectionOnClick
          slots={{
            toolbar: GridToolbar,
            footer: () => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 2,
                  backgroundColor: `${color}15`,
                  color: color,
                  fontWeight: 700,
                  fontSize: "1.1rem",
                }}
              >
                <Typography flex={6}>الإجمالي</Typography>
                <Typography flex={1}>{formatNumber(total)}</Typography>
              </Box>
            ),
          }}
        />
      
      {/* </Box> */}
    </>
  );
};

export default AccountDataGrid;
